"use strict";var e=require("../Constant/DeviceName.cjs");exports.humaniseDeviceId=function(i){var r;return null!==(r=e.DeviceName[i])&&void 0!==r?r:e.DeviceName.UNKNOWN};
//# sourceMappingURL=humaniseDeviceId.cjs.map
